export default __webpack_public_path__ + "static/media/OLY1.3fae7185.png";